<template>
  <div class="big orderReceipt">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">订单收货监测记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="search_box">
          <div class="item">
            <span class="itemtitle">处方号</span>
            <el-input
              style="width:180px"
              v-model="orderForm.pre_id"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">订单号</span>
            <el-input
              v-model="orderForm.order_sn"
              clearable
              style="width:180px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="orderForm.doctor_name"
              clearable
              style="width:180px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">患者姓名</span>
            <el-input
              v-model="orderForm.user_name"
              clearable
              style="width:180px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">订单状态</span>
            <el-select
              v-model="orderForm.order_status"
              clearable
              @change="search"
              style="width:180px"
            >
              <el-option
                label="全部"
                :value="0"
              ></el-option>
              <el-option
                label="待收货"
                :value="3"
              ></el-option>
              <el-option
                label="已收货"
                :value="4"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">快递方式</span>
            <el-select
              v-model="orderForm.delivery"
              clearable
              @change="search"
              style="width:180px"
            >
              <el-option
                label="全部"
                :value="0"
              ></el-option>
              <el-option
                label="快递"
                :value="1"
              ></el-option>
              <el-option
                label="自提"
                :value="2"
              ></el-option>
              <el-option
                label="闪送"
                :value="3"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">支付时间</span>
            <el-date-picker
              v-model="orderForm.pay_time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              style="width:230px"
              @change="search"
            >
            </el-date-picker>
          </div>

          <div class="item">
            <span class="itemtitle">发货时间</span>
            <el-date-picker
              v-model="orderForm.send_time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              style="width:230px"
              @change="search"
            >
            </el-date-picker>
          </div>
          <div class="item">
            <span class="itemtitle">收货时间</span>
            <el-date-picker
              v-model="orderForm.completionTime"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              style="width:230px"
              @change="search"
            >
            </el-date-picker>
          </div>
          <div class="item">
            <div style="width:120px;text-align:right;margin-right:8px">支付-收货耗时</div>
            <el-select
              v-model="orderForm.sc_time_start"
              clearable
              @change="search(1)"
              style="width:100px"
            >
              <el-option
                v-for="item in 31"
                :key="item"
                :label="item-1+'天'"
                :value="item-1"
              >
              </el-option>
            </el-select>
            <span style="margin:0 3px">-</span>
            <el-select
              v-model="orderForm.sc_time_end"
              clearable
              @change="search(1)"
              style="width:100px"
            >
              <el-option
                v-for="item in 31"
                :key="item"
                :label="item-1+'天'"
                :value="item-1"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              style="margin-left:20px"
              @click="search"
            >查询</el-button>
            <el-button @click="restBtn">重置</el-button>
          </div>
          <div class="item">
            <div style="margin-right:8px">收货监测状态</div>
            <span>
              <el-radio-group
                v-model="orderForm.order_status"
                @change="search"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="3">待收货</el-radio>
                <el-radio :label="4">已收货</el-radio>
              </el-radio-group>
            </span>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
          >
            <el-table-column
              prop="pre_id"
              label="处方号"
            >
            </el-table-column>
            <el-table-column
              prop="order_sn"
              label="订单号"
            ></el-table-column>
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            >
              <template slot-scope="scope">
                <span
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="user_name"
              label="患者姓名"
            ></el-table-column>
            <el-table-column
              prop="hospital_name"
              label="药房名称"
            ></el-table-column>
            <el-table-column
              prop="pay_time"
              label="支付时间"
            ></el-table-column>
            <el-table-column
              prop="send_time"
              label="发货时间"
            ></el-table-column>
            <el-table-column
              prop="completion_time"
              label="收货时间"
            ></el-table-column>
            <el-table-column
              prop="sc_time"
              label="支付-收货耗时"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{scope.row.sc_time>=0?scope.row.sc_time+"天":""}}
              </template>
            </el-table-column>
            <el-table-column
              prop="is_receive"
              label="收货监测状态"
            ></el-table-column>
            <el-table-column label="订单状态">
              <template slot-scope="scope">
                <div v-if="scope.row.order_status==3">待收货</div>
                <div v-if="scope.row.order_status==4">已完成</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled=" module_id_array[0] ? !module_id_array.includes('115') : false"
                  @click="toDetail(scope.row)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import systemWarning from '@/api/systemWarning.js';
import Pagination from '@/components/Pagination/index';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: {
    Pagination,
    DocMsg
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      orderForm: {
        pre_id: '',
        order_sn: '',
        doctor_name: '',
        user_name: '',
        sc_time_start: undefined,
        sc_time_end: undefined,
        pay_time: [],
        send_time: [],
        completionTime: [],
        order_status: '',
        delivery: 1,
        orderby: 0,
        order_status: 0
      },
      tableData: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  activated() {
    this.initCompletionTime();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    initCompletionTime() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format('YYYY-MM-DD');
      start = dayjs(start).format('YYYY-MM-DD');
      this.orderForm.pay_time = [start, end];
    },
    getList() {
      if (
        this.orderForm.sc_time_start &&
        this.orderForm.sc_time_end &&
        this.orderForm.sc_time_start > this.orderForm.sc_time_end
      ) {
        this.$message.warning('开始耗时须小于结束耗时');
        return false;
      }
      let data = Object.assign(this.pagination, this.orderForm);
      data = _.omit(data, ['pay_time', 'send_time', 'completionTime']);
      if (this.orderForm.pay_time && this.orderForm.pay_time.length) {
        data.pay_time_start = this.orderForm.pay_time[0];
        data.pay_time_end = this.orderForm.pay_time[1];
      }
      if (this.orderForm.send_time && this.orderForm.send_time.length) {
        data.send_time_start = this.orderForm.send_time[0];
        data.send_time_end = this.orderForm.send_time[1];
      }
      if (
        this.orderForm.completionTime &&
        this.orderForm.completionTime.length
      ) {
        data.completion_time_start = this.orderForm.completionTime[0];
        data.completion_time_end = this.orderForm.completionTime[1];
      }
      this.tableLoading = true;
      systemWarning.orderReceivingMonitor(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.pay_time = dayjs
              .unix(item.pay_time)
              .format('YYYY-MM-DD HH:mm');
            item.send_time = dayjs
              .unix(item.send_time)
              .format('YYYY-MM-DD HH:mm');
            item.completion_time = item.completion_time
              ? dayjs.unix(item.completion_time).format('YYYY-MM-DD HH:mm')
              : '';
            item.is_receive = item.completion_time ? '已收货' : '未收货';
            return item;
          });
          this.totalNum = res.data.total;
          this.tableLoading = false;
        }
      });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == 'ascending') {
        if (prop == 'sc_time') {
          this.orderForm.orderby = 1;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'sc_time') {
          this.orderForm.orderby = 2;
        }
      }
      if (!order) {
        this.orderForm.orderby = 0;
      }
      this.getList();
    },
    search(type) {
      if (type) {
        if (
          (this.orderForm.sc_time_start && !this.orderForm.sc_time_end) ||
          (!this.orderForm.sc_time_start && this.orderForm.sc_time_end)
        ) {
          return false;
        }
      }
      this.pagination.page = 1;
      this.getList();
    },
    toDetail(row) {
      this.$router.push({
        path: '/home/order/orderdetail',
        query: {
          order_id: row.order_id
        }
      });
    },
    restBtn() {
      this.orderForm = {
        pre_id: '',
        order_sn: '',
        doctor_name: '',
        user_name: '',
        sc_time_start: undefined,
        sc_time_end: undefined,
        pay_time: [],
        send_time: [],
        completionTime: [],
        order_status: '',
        delivery: 1,
        orderby: 0,
        order_status: 0
      };
      this.pagination.page = 1;
      this.pagination.pageNumber = 10;
      this.initCompletionTime();
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}
.search_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .itemtitle {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      text-align: right;
    }
  }
}
</style>